/**
 * <ldy-barra-fissa> — bottone fluttuante del telefono nella scheda prodotto (impianto modello).
 * Compare quando il bottone vero dell'offerta è uscito dallo schermo verso l'alto; sparisce quando si vede
 * il bottone vero o quando arriva il piede. Copia testo e prezzo del bottone vero. Al tocco riporta all'offerta.
 */
class LdyBarraFissa extends HTMLElement {
  /** @type {AbortController | null} */
  #controllo = null;
  /** @type {IntersectionObserver | null} */
  #osservaBottone = null;
  /** @type {IntersectionObserver | null} */
  #osservaPiede = null;
  /** @type {MutationObserver | null} */
  #osservaTesto = null;
  #bottoneSopra = false;
  #piedeVisto = false;

  connectedCallback() {
    this.#controllo?.abort();
    this.#controllo = new AbortController();
    const { signal } = this.#controllo;

    const offerta = this.closest('ldy-offerta-component');
    const bottone = offerta?.querySelector('[ref="bottone"]');
    const testo = offerta?.querySelector('[ref="testoBottone"]');
    if (!(offerta instanceof HTMLElement) || !(bottone instanceof HTMLElement)) return;

    const copia = () => {
      const dove = this.querySelector('[data-barra-testo]');
      const nuovo = testo?.textContent?.replace(/\s+/g, ' ').trim() ?? '';
      if (dove && dove.textContent !== nuovo) dove.textContent = nuovo;
    };
    copia();
    if (testo) {
      this.#osservaTesto = new MutationObserver(copia);
      this.#osservaTesto.observe(testo, { childList: true, characterData: true, subtree: true });
    }

    this.#osservaBottone = new IntersectionObserver(([voce]) => {
      if (!voce) return;
      this.#bottoneSopra = !voce.isIntersecting && voce.boundingClientRect.top < 0;
      this.#aggiorna();
    });
    this.#osservaBottone.observe(bottone);

    const piede = document.querySelector('.shopify-section-group-footer-group, footer');
    if (piede) {
      this.#osservaPiede = new IntersectionObserver(([voce]) => {
        this.#piedeVisto = Boolean(voce?.isIntersecting);
        this.#aggiorna();
      });
      this.#osservaPiede.observe(piede);
    }

    this.querySelector('button')?.addEventListener(
      'click',
      () => {
        const ridotto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const testata = document.querySelector('#header-group, .header-section')?.getBoundingClientRect().height ?? 0;
        const y = offerta.getBoundingClientRect().top + window.scrollY - testata - 12;
        window.scrollTo({ top: Math.max(0, y), behavior: ridotto ? 'auto' : 'smooth' });
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#controllo?.abort();
    this.#osservaBottone?.disconnect();
    this.#osservaPiede?.disconnect();
    this.#osservaTesto?.disconnect();
  }

  #aggiorna() {
    this.classList.toggle('is-visibile', this.#bottoneSopra && !this.#piedeVisto);
  }
}

if (!customElements.get('ldy-barra-fissa')) {
  customElements.define('ldy-barra-fissa', LdyBarraFissa);
}
